import ActionTypes from './constants';

const ReviewOrderReducer = (
  state = { fetched: false, fetchedAdyen: false },
  payload
) => {
  switch (payload.type) {
    case ActionTypes.FetchedCreditCards:
      return { ...state, fetched: true, paymentCards: payload.cards };
    case ActionTypes.FetchedCreditCardsAdyen:
      return { ...state, fetchedAdyen: true, paymentCardsAdyen: payload.cards };
    default:
      return state;
  }
};

export default ReviewOrderReducer;
